import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EMaxPrepay } from '../../../../../../../json_query';
import { changeMaxPrepay, changeWithoutDeposit } from '../../../../../../state/advanced/rent_terms';
import { changeComissionType } from '../../../../../../state/advanced/comission';
import { RentTermsComponent } from './rentTerms';

export function mapStateToProps(state: IAppState) {
  return {
    commissionType:
      (state.filters.jsonQuery.commission_type && state.filters.jsonQuery.commission_type.value === 0) || false,
    maxPrepay: (state.filters.jsonQuery.prepay && state.filters.jsonQuery.prepay.value) || EMaxPrepay.Any,
    withoutDeposit: state.filters.jsonQuery.zalog !== undefined ? !state.filters.jsonQuery.zalog.value : false,
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onComissionTypeChanged: (value: number | undefined) => {
      dispatch(changeComissionType(value));
    },
    onMaxPrepayChanged: (value: EMaxPrepay) => {
      dispatch(changeMaxPrepay(value));
    },
    onWithoutDepositChanged: (value: boolean) => {
      dispatch(changeWithoutDeposit(value));
    },
  };
}

export const RentTerms = connect(mapStateToProps, mapDispatchToProps)(RentTermsComponent);
